module.exports = __webpack_public_path__ + "img/card-specialists-hover.4b45a31c.svg";